var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __decorateClass = (decorators, target, key, kind) => {
  var result = kind > 1 ? void 0 : kind ? __getOwnPropDesc(target, key) : target;
  for (var i = decorators.length - 1, decorator; i >= 0; i--)
    if (decorator = decorators[i])
      result = (kind ? decorator(target, key, result) : decorator(result)) || result;
  if (kind && result)
    __defProp(target, key, result);
  return result;
};

// client/components/x-tiptap-action-bar.ts
import { ChemistryLitElement } from "@adornis/chemistry/chemistry-lit-element.js";
import { acss } from "@adornis/chemistry/directives/acss.js";
import { css } from "@adornis/chemistry/directives/css.js";
import "@adornis/chemistry/elements/components/x-button";
import "@adornis/chemistry/elements/components/x-flex.js";
import "@adornis/chemistry/elements/components/x-grid.js";
import "@adornis/chemistry/elements/components/x-icon";
import "@adornis/chemistry/elements/components/x-vr.js";
import { xComponents } from "@adornis/chemistry/elements/x-components.js";
import { TranslationController } from "@adornis/translation-core/client/translation-controller.js";
import { html, nothing } from "lit";
import { customElement, property } from "lit/decorators.js";
import { fromEvent, takeUntil } from "rxjs";
import {
  ActionbarDropdown,
  ActionbarSpacer
} from "./actionbarElements.js";
import "./x-tiptap-action-bar-dropdown.js";
var XTiptapActionBar = class extends ChemistryLitElement {
  constructor() {
    super(...arguments);
    this.extensions = [];
    this.translator = new TranslationController(this);
  }
  connectedCallback() {
    super.connectedCallback();
  }
  firstUpdated(changedProperties) {
    super.firstUpdated(changedProperties);
    if (!this.editor) {
      console.warn("toolbar has no editor");
      return;
    }
    fromEvent(this.editor, "selectionUpdate").pipe(takeUntil(this.disconnected)).subscribe(() => this.requestUpdate());
  }
  render() {
    if (!this.editor || !this.extensions)
      return nothing;
    const editor = this.editor;
    const buttonGroups = this.extensions.map(
      (group) => group.flatMap((extension) => extension.buttons?.({ editor, host: this }) ?? [])
    );
    let groupCount = 0;
    const buttonTemplate = buttonGroups.map((group, index, groups) => {
      const buttons = group.map((elem) => {
        if (elem instanceof ActionbarDropdown) {
          return this._actionDropdown(elem);
        }
        return this._actionButton(elem);
      });
      if (!buttons.length)
        return nothing;
      groupCount++;
      const renderVerticalBar = groupCount > 1 && group[0]?.name !== ActionbarSpacer && groups[index - 1]?.[0]?.name !== ActionbarSpacer;
      return renderVerticalBar ? html` <x-vr ${css({ height: "unset" })}></x-vr> ${buttons} ` : buttons;
    });
    return xComponents(html` <x-flex horizontal space="xxs" wrap> ${buttonTemplate} </x-flex> `);
  }
  _actionDropdown(dropdown) {
    return html` <x-tiptap-action-bar-dropdown .dropdown=${dropdown}></x-tiptap-action-bar-dropdown> `;
  }
  _actionButton({ action, icon, color, background, tooltip, name }) {
    if (!this.editor)
      throw new Error("rendering action button without editor reference?");
    if (name === ActionbarSpacer)
      return html` <div flex></div> `;
    return html`
      <x-icon
        class="toolbar-button"
        @click=${() => action?.()}
        ${acss({
      color: color ?? this.colors.neutral,
      background: background ?? "none",
      "&:hover": { background: this.colors.neutral.shade(50) }
    })}
      >
        ${icon} ${tooltip ? html` <x-tooltip> <x-text> ${tooltip} </x-text> </x-tooltip> ` : nothing}
      </x-icon>
    `;
  }
  styles() {
    return [
      ...super.styles(),
      {
        ":host": {
          position: "sticky",
          top: "0px",
          background: this.colors.white,
          padding: "4px 8px"
        },
        ".toolbar-button": {
          fontSize: "24px",
          borderRadius: "4px",
          padding: "2px"
        }
      }
    ];
  }
};
__decorateClass([
  property({ attribute: false })
], XTiptapActionBar.prototype, "extensions", 2);
__decorateClass([
  property({ attribute: false })
], XTiptapActionBar.prototype, "editor", 2);
XTiptapActionBar = __decorateClass([
  customElement("x-tiptap-action-bar")
], XTiptapActionBar);
export {
  XTiptapActionBar
};
